import angular from 'angular';

var SECURITY_HIDDEN_CLASS = 'no-access-configuration';

angular.module('cloudX').directive('cxTenantConfiguration', [
  '$rootScope',
  'checkTenantConfiguration',
  'authService',
  function($rootScope, checkTenantConfiguration, authService) {
    return {
      restrict: 'A',
      link: function(scope, element, attr) {
        var security = '';
        var doCheck = function() {
          if (checkTenantConfiguration(security)) element.removeClass(SECURITY_HIDDEN_CLASS);
          else element.addClass(SECURITY_HIDDEN_CLASS);
        };

        attr.$observe('cxTenantConfiguration', function() {
          security = attr.cxTenantConfiguration;
          doCheck();
        });

        var destroyer = $rootScope.$on('$cxAuthenticated', function() {
          doCheck();
        });
        scope.$on('$destroy', function() {
          destroyer();
        });

        authService.addOnNewToken(function(token) {
          doCheck();
        });
      },
    };
  },
]);
